import React, { useState } from "react";
import { DateTime } from "luxon";

const DataAccordion = ({
  eventDate,
  eventType,
  eventTitle,
  eventDescription,
  eventAddress,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const dateString = DateTime.fromMillis(eventDate).toFormat("DD");

  return (
    // When the idTimeStamp is bigger then the current JS timestamp the div is visible
    <div className="max-w-[1248px] w-full mx-auto text-[#01184D] md:text-xl sm:text-lg text-sm">
      <div>
        <button
          className="flex justify-between items-center w-full px-4 py-2 text-left bg-white active:bg-gray-200 hover:bg-gray-300 border-[#01184D] border-b"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="font-bold">{dateString} </span>
          <p>{eventType}</p>
          <span
            className={`transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          >
            ▼
          </span>
        </button>
        <div
          className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${
            isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          }`}
          style={{ transitionProperty: "max-height, opacity" }}
        >
          {isOpen && (
            <div className="px-4 py-2 text-left accordion-body bg-white border-[#01184D] border-b ">
              <h1 className="font-bold py-2">{eventTitle}</h1>

              <p>
                <span className="font-bold py-2">Description: </span>
                {eventDescription}
              </p>
              <h1 className="font-bold py-2">
                Address: <span className="font-normal">{eventAddress}</span>
              </h1>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataAccordion;
